module.exports = __webpack_public_path__ + "static/logo_black-f68e572d28278f5ca2d59983dbebac3b.png";